export class BaseModel {
  static create(data, source = 'api') {
    if (!data) return null;

    const instance = new this();
    instance.hydrate(data, source);
    return instance;
  }
}
